import {
  useDisclosure, Drawer, DrawerContent, DrawerOverlay, Button, Box, Text,
} from '@chakra-ui/react';

import React, { ReactElement } from 'react';
import Basket from './basketDetail';
import { useGetBasketQuery } from '../../lib/graphql';
import formatMoney from '../../utils/money';
import { previewTotal } from '../../utils/basketTotals';

const BasketFooter = (): ReactElement|null => {
  const { data, loading } = useGetBasketQuery();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const toggleDrawer = () => {
    if (isOpen) {
      onClose();
    } else {
      onOpen();
    }
  };

  if (loading) {
    return null;
  }

  if (!data || !data?.getBasket?.basket) {
    return null;
  }

  const { basket } = data.getBasket;

  // Hide footer if basket is empty
  if (!basket?.items?.length) {
    return null;
  }

  // Fee is excluded from the preview (see utils/basketTotals) — the collapsed
  // bar and the expanded summary must quote the same figure.
  const displayTotal = previewTotal(basket);

  return (
    <Box
      position="fixed"
      bottom="0"
      left="0"
      right="0"
      zIndex="sticky"
      paddingBottom="env(safe-area-inset-bottom)"
      backgroundColor="yellow.400"
    >
      <Button
        onClick={toggleDrawer}
        w="100%"
        h="56px"
        variant="footerButton"
        colorScheme="yellow"
      >
        <Text fontSize="lg" fontWeight="bold">View Basket</Text>
        <Box position="absolute" right={4}><Text fontSize="md" fontWeight="bold">{formatMoney(displayTotal)}</Text></Box>
      </Button>
      <Drawer id="buttomMenu" isOpen={isOpen} onClose={onClose} placement="bottom" size="sm">
        <DrawerOverlay>
          <DrawerContent p={2}>
            <Basket />
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    </Box>
  );
};

export default BasketFooter;
